<template>
    <div class="container">
        <div class="filter_path">
            <el-form :inline="true" :model="params" class="form-inline">
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="供应商" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input class="filter_input" v-model="params.keyword" placeholder="提单号" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input class="filter_input" v-model="params.keyword" placeholder="仓库" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker class="filter_input" v-model="params.keyword" type="date" placeholder="入库时间" size="mini"></el-date-picker>
                </el-form-item>
                <br>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="品种" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="等级" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select class="filter_input" v-model="params.belong" placeholder="长度" size="mini">
                        <el-option value="1">123</el-option>
                        <el-option value="2">123</el-option>
                        <el-option value="3">123</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input class="filter_input" v-model="params.keyword" placeholder="厚度" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-link type="primary" :underline="false">重置查询</el-link>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="operate_row">
            <div class="">
                <el-button size="customize">库龄预警</el-button>
                <el-button type="primary" size="customize">修改</el-button>
            </div>
        </div>
        <div class="table_path">
            <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                <el-table-column type="index"></el-table-column>
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="捆包号"></el-table-column>
                <el-table-column label="品牌"></el-table-column>
                <el-table-column label="品名"></el-table-column>
                <el-table-column label="等级"></el-table-column>
                <el-table-column label="厚度"></el-table-column>
                <el-table-column label="长度"></el-table-column>
                <el-table-column label="销售立方"></el-table-column>
                <el-table-column label="成本价"></el-table-column>
                <el-table-column label="挂牌价"></el-table-column>
                <el-table-column label="最低价"></el-table-column>
                <el-table-column label="状态"></el-table-column>
                <el-table-column label="入库日期"></el-table-column>
                <el-table-column label="合同号"></el-table-column>
                <el-table-column label="仓库"></el-table-column>
                <el-table-column label="提单号"></el-table-column>
                <el-table-column label="备注"></el-table-column>
                <el-table-column label="更新日期"></el-table-column>
            </el-table>
        </div>
        <div class="pagination_path">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="statistics">
            <span>合计立方：12154</span>
            <span>合计件数：12154</span>
        </div>

        <!-- 商品详情 dialog START -->
        <el-dialog v-dialog-drag title="商品详情" :visible.sync="dialogVisible" width="700px">
            <div class="">
                <hr class="dialog_hr">
                <el-table :data="list" style="width: 100%" border size="mini" header-cell-class-name="list_table_th">
                    <el-table-column type="index" label="#"></el-table-column>
                    <el-table-column label="锁定单号"></el-table-column>
                    <el-table-column label="锁定方数"></el-table-column>
                    <el-table-column label="锁定人"></el-table-column>
                    <el-table-column label="锁定时间"></el-table-column>
                    <el-table-column label="资源状态"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <!-- 商品详情 dialog END -->

    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;

        .filter_path{
            padding: 15px; background-color: #F4F5F9;
            .filter_input{
                width: 120px;
                & + .filter_input{ margin-left: 34px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
            // .excel_btn{
            //     color: #B21111; cursor: pointer;
            // }
        }
        .table_path{ flex: 1; }
        .statistics{
            background: #F7F8FA; padding: 14px 12px; line-height:22px; margin-top: 10px; display: flex; align-items: flex-start; font-size: 16px; color: #333333;
            span + span{ margin-left: 195px; }
        }
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                tab : 1,
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],

                // 商品详情 dialog START
                dialogVisible: false,

                // 商品详情 dialog END
            }
        },
        methods:{
            changeTab(tab){
                this.$set(this,"tab",tab);
            },
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
    }
</script>
